import jquery from "jquery";

window.$ = jquery;
window.jQuery = jquery;

(function($){
	jquery.extend({      
		collectFormValues: function(el) {   
			const data = {};
			$(el).find('input,select,textarea').each(function(){
				const name = $(this).attr('name');
				const type = $(this).attr('type');
				if(type == 'radio'){
					if($(this).is(':checked')){
						data[name] = $(this).val();
					}
				}else{
					data[name] = $(this).val();
				}
			});
			return data;  
		},
		positionWarpAndScrollToActive: function(elObj, activeClass = 'active'){
			if(elObj instanceof jQuery){
				elObj.each(function(){
					const clientWidth = $(this)[0].clientWidth;
					const activeEl = $(this).find(`.${activeClass}`);
					if(activeEl.length){
						const offsetLeft = activeEl[0].offsetLeft;
						const activeElWidth = activeEl[0].clientWidth;
						const _equalWidth = (clientWidth - activeElWidth) / 2;
						$(this).animate({
							scrollLeft: offsetLeft - _equalWidth
						},300);
					}
				})
			}
		}
	})
	$.fn.diyScroll = function(options = {}) {
		const trackScroll = (el) => {
			const scrollContainer = el;
			const scrollPosition = scrollContainer.scrollLeft;
			const contentWidth = scrollContainer.scrollWidth - scrollContainer.clientWidth;
			const scrollProgress = (scrollPosition / contentWidth) * 100;
			return scrollProgress.toFixed(2);
		}
		const { type = 'step' } = options;
		return this.each(function(){
			if($(this).hasClass('_custom-scroll-init')){
				return false;
			}
			const progressBar = `<div class="progressbar-replacement"><div class="progress-line ${type == 'step'?'progress-line-step':''}"><div class="bar"></div></div></div>`;
			const classList = ['_custom-scroll-init','overflow-area-scrollbar-hide'];
			$(this).addClass(classList).after(progressBar);
			const bar = $(this).next('.progressbar-replacement').find('.bar');
			const onScrollfun = function(){
				const process = trackScroll($(this)[0]);
				if(type == 'step'){
					bar.css('left',`${process * 0.7}%`);
				}else{
					bar.css('width',`${process}%`);
				}
			}
			$(this).on('scroll',onScrollfun);
		});
	}
	$.fn.generateStartEvaluate = function(options = {}) {
		const { 
			name = 'rating', 
			half = true, 
			score = 5, 
			value = 0,
			onChange = null 
		} = options;

		const _buildStart = (max, goal) => {
			const startEl = [];
			for(let i = 0; i < max; i++){
				const _class = goal>0?(goal>=1?'full':'half'):'line';
				startEl.push(`<i data-score="${i + 1}" class="_start-item c-icon-start-${_class}"></i>`);
				if(goal > 0){
					goal -= 1;
				}
			}
			return startEl;
		}

		const input = `<input type="hidden" name="${name}" value="${value}"/>`;
		this.each(function(){
			const startEl = _buildStart(score, value);
			$(this).html(`<div class="start-evaluate-container"><div class="start-area">${startEl.join('')}</div>${input}</div>`).off('click').on('click','._start-item',function(event){
				let _score = +$(this).attr('data-score');
				if(half){
					const element = $(this)[0];
					const clickX = event.clientX;
					const elementOffsetX = element.getBoundingClientRect().left;
					if(clickX < elementOffsetX + element.offsetWidth / 2){
						_score -= 0.5;
					}
				}
				const startEl = _buildStart(score, _score);
				$(this).parent().html(startEl.join('')).next('input').val(_score);
				onChange && onChange(_score);
			});
		})
	}
	$.ajaxSetup({
		beforeSend: (xhr, settings) => {},
		complete: (xhr, status) => {},
		error: (xhr, status, error) => {
			if(status == 'error'){
				console.log(status, error);
				let errorMsg = 'Service unavailable, please try again later';
				try{
					if(xhr.responseText){
						const { message } = JSON.parse(xhr.responseText);
						if(message){
							errorMsg = message;
						}
					}
				}catch(err){

				}
				kte.globalTip(errorMsg,'fail');
			}
		}
	})
})($);

import './part/kte.js';

window.addEventListener('error',(event) => {
	const target = event.target;
	if (target instanceof HTMLImageElement) {
		const targetSrc = target.src || '';
		let src = '/static/catalog/public/ktem-assets/img/img-error.png';
		const assetsUrl = kte.assetsUrl;
		if(assetsUrl){
			src = `${assetsUrl}/${src}`;
		}
		if(targetSrc.endsWith(src)){
			return;
		}
		target.src = kte.cleanUrl(src);
	}
},true);

window.addEventListener('load', function () {
	setTimeout(() => {
		import('./part/boot.js').then(() => {
			console.log('boot loaded');
		});
	}, 60);
});
